import Button from 'components/button'
import { Question, SurveyResponse } from 'contexts/survey-context/survey.interface'
import { useState } from 'react';
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import toast from 'react-hot-toast';
import ProfileService from 'services/profile-services';
import { useSession } from 'contexts/session-context';
import { useLocalStorage } from 'react-use';
import { TitleSurvey } from '../../../styles/styled.components'
import Options from '../../options';

interface IProps {
  id: number;
  title: string;
  answers: any;
  questions: Question[];
  handleSubmit: (callback: () => Promise<void>) => void
  updatePolarisSurvey: (select: SurveyResponse[][], id: number) => Promise<void>
}

const StepTwo = ({ id, title, questions, answers, handleSubmit, updatePolarisSurvey }: IProps) => {
  const [{ data: session }, { setUser }] = useSession()
  const [state, setState] = useLocalStorage('state', {})
  const [selected, setSelected] = useState<Record<string, number[]>>({})
  const [textValue, setTextValue] = useState<Record<string, string>>({})

  const validateAmountAnwsers = (select: SurveyResponse[][]) => {
    if (questions?.length !== select?.length) return true

    const selectedFilter = select?.filter((item, index) => {
      let amountAnswers = questions[index]?.type === 'Normal' ? questions[index]?.amountAwnsers : 1
      if (questions[index]?.type === 'Normal') {
        const anwser = questions[index]?.options.filter(
          (o) => (item as any)?.optionIds.find((x) => x === o.optionId) === o.optionId
        )
        if (anwser.some((o) => o.demandSpaceId === 0)) {
          amountAnswers = 0
        }
      }

      if (questions[index]?.type === 'TextBox') {
        return (item as any)?.textValue === '' || !(item as any)?.textValue
      }

      return (item as any)?.optionIds.length < amountAnswers
    })
    return selectedFilter?.length > 0
  }

  const onSubmit = async () => {

    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'Responder',
      section: `survey`
    })

    const select = []

    for (const key in selected) {
      select.push({ questionId: parseInt(key), optionIds: selected[key]?.filter((id) => !!id), textValue: textValue[key] !== '' ? textValue[key] : null })
    }

    if (validateAmountAnwsers(select)) {
      dlTrackEvent('error', {
        error_type: 'survey',
        error_code: 9999,
        error_message: 'Por favor, responde todas las preguntas',
        section: `survey`
      })
      return alert('Por favor, responde todas las preguntas')
    }

    const questionInstagram = questions?.find((q) => q.question.toLowerCase().includes('cuenta de ig'))

    if (questionInstagram) {
      let instagram = select.find((s) => s.questionId === questionInstagram?.questionId)?.textValue

      if (!instagram.includes('@') && instagram) {
        instagram = `@${instagram}`
      }

      const result = await ProfileService.instagram(instagram, session)
      setState({ ...state, user: result?.data })
      setUser(result?.data)
      toast.success('Los cambios se guardaron con éxito', { className: 'toast__success' })
    }

    answers.push(...select)

    await updatePolarisSurvey(answers as any as SurveyResponse[][], id)
  }

  return (
    <div className="flex justify-between flex-col flex-1 items-center h-full w-full survey-container">
      <div className="w-full px-6 flex-1">
        <div className='flex flex-col justify-center items-center pt-4'>
          <TitleSurvey className="font-black text-4xl text-center title-survey">Encuesta</TitleSurvey>
          <TitleSurvey className="font-black text-4xl text-center title-survey">{title}</TitleSurvey>
          <p className='text big text-center pt-2'>Cuéntanos por qué quieres asistir a esta fiesta by Heineken. Responde lo que mejor te represente.</p>
        </div>

        <div className='container-survey mt-5'>
          {questions?.map(({ questionId, question, subtitle, options, type, amountAwnsers, columns }, index) => (
            <Options
              onChange={(data, select, value) => {
                setTextValue((state) => ({ ...state, [data]: value }))
                setSelected((state) => ({ ...state, [data]: select.map((id) => +id) }))
              }}
              options={options}
              question={question}
              subtitle={subtitle}
              questionId={questionId}
              type={type}
              key={index}
              amountAnswers={amountAwnsers}
              columns={columns}
            />
          ))}
        </div>
      </div>

      <div className='mt-10 mb-12' style={{ minWidth: '323px' }}>
        <Button className='w-full' onClick={() => handleSubmit(onSubmit)}>Responder</Button>
      </div>
    </div>
  )
}

export default StepTwo